import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function ElectricIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M7.06258 18.5001H12.5837L11.4438 29.2764C11.4388 29.3088 11.4374 29.4049 11.4374 29.4374C11.4374 30.2987 12.1387 31 13 31C13.49 31 13.9574 30.765 14.2675 30.3489L25.1875 14.7501C25.3887 14.4811 25.5 14.1488 25.5 13.8126C25.5 12.9513 24.7989 12.25 23.9376 12.25H17.1801L18.3051 2.74614C18.3087 2.70997 18.3112 2.59875 18.3112 2.56258C18.3126 1.70129 17.6113 1 16.75 1C16.26 1 15.7926 1.23506 15.4726 1.66376L5.81242 16C5.61124 16.2687 5.5 16.6012 5.5 16.9375C5.5 17.7988 6.20129 18.5001 7.06258 18.5001Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
